// Pure helper for resolving the backend WebSocket URL.
//
// Lives in its own module so it can be unit-tested without loading the DOM-
// dependent rest of `live-session.js`. Priority:
//   1. `runtimeConfig.wsUrl` (the runtime-config loader fills this in).
//   2. Same-origin fallback derived from `location` for legacy use.

export function resolveWsUrl({ runtimeConfig, location: loc } = {}) {
  if (runtimeConfig && runtimeConfig.wsUrl) return runtimeConfig.wsUrl;
  const here = loc || (typeof location !== "undefined" ? location : null);
  if (!here) return null;
  const proto = here.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${here.host}/api/v1/live/ws`;
}
